<template>
  <div v-if="userInfo?.websiteManage" class="main-view">
    <router-view />
    <van-tabbar route style="height: 50px">
      <van-tabbar-item replace to="/leave/todo" icon="location-o"
        >请假</van-tabbar-item
      >
      <van-tabbar-item replace to="/leave/approvelist" icon="chart-trending-o"
        >审批</van-tabbar-item
      >
    </van-tabbar>
  </div>
  <div v-else class="main-view">
    <todo-view />
  </div>
</template>

<script setup lang="ts">
// import { useRoute } from "vue-router";
import todoView from "./todo/index.vue";
import { userAuthStore } from "@/store/auth";

// const route = useRoute();
const common = userAuthStore();
const userInfo: any = ref({ ...common.currUserData });
onMounted(() => {
  // if (route.query && route.query.token) {
  //   common.authToken = route.query.token;
  //   console.log("route", common.authToken);
  //   userInfo.value = common.currentDate;
  // }
});
</script>

<style scoped>
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
